// Catálogo de MiniForms de flow (src/components/landing/MiniForm*.tsx) asignables a un plan.
// La asignación vive en descripcion_json.calculatorConfig.miniform: el microservicio
// calculator ignora el campo, y flow puede leerlo para decidir qué miniform renderizar.
export const MINIFORMS = [
  {
    value: "complementario",
    label: "MiniForm Complementario",
    usaCalculator: true,
    tiposSugeridos: ["tramo_edad"],
    descripcion: "Pide fecha de nacimiento y nº de cargas. Envía { planId, fechaNacimiento, cargas }.",
  },
  {
    value: "monto_tasa",
    label: "MiniForm Monto/Tasa",
    usaCalculator: true,
    tiposSugeridos: ["monto_tasa"],
    descripcion: "Pide el monto asegurado (ej. valor de la bicicleta, en UF). Envía { planId, montoAsegurado }. Para planes monto_tasa con montoAsegurado.origen: \"request\".",
  },
  {
    value: "hogar",
    label: "MiniForm Hogar",
    usaCalculator: false,
    tiposSugeridos: [],
    descripcion: "Cotiza vía REALLE (tadmin /api/hogar/cotizar); no usa el microservicio calculator.",
  },
  {
    value: "incendio",
    label: "MiniForm Incendio",
    usaCalculator: true,
    tiposSugeridos: ["construccion_comuna"],
    descripcion: "Pide tipo de construcción y comuna. Envía atributos { tipo_construccion, comunas }.",
  },
  {
    value: "pet",
    label: "MiniForm Pet",
    usaCalculator: true,
    tiposSugeridos: ["por_mascota"],
    descripcion: "Pide nº de mascotas (1–5). Envía atributos { numero_mascotas }.",
  },
  {
    value: "rc_medica",
    label: "MiniForm RC Médica",
    usaCalculator: true,
    tiposSugeridos: ["precio_base_atributos"],
    descripcion: "Pide especialidad. Envía atributos { especialidad }.",
  },
  {
    // Genérico por unidad: a diferencia de Pet, el nombre del atributo de
    // cantidad sale de calculatorConfig.cantidad.atributo, así que un producto
    // nuevo que cobre por unidad no necesita un miniform propio.
    value: "precio_cantidad",
    label: "MiniForm Precio × Cantidad",
    usaCalculator: true,
    tiposSugeridos: ["precio_cantidad"],
    descripcion:
      "Pide SOLO la cantidad (ej. nº de guardias). Envía atributos { [cantidad.atributo]: n }. Los datos de cada unidad (RUT, cargas) los pide el plan por descripcion_json.modulos_requeridos, no el miniform.",
  },
];

export function getMiniform(value) {
  return MINIFORMS.find((m) => m.value === value) || null;
}

export function miniformSugeridoParaTipo(type) {
  return MINIFORMS.find((m) => m.tiposSugeridos.includes(type)) || null;
}
